// extracted by mini-css-extract-plugin
export default {"card":"components-timeTracking-TimeTrackingActivityToSelectListItem-__card"};